module.exports = __webpack_public_path__ + "img/discount.abed265c.png";